import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <select
      className="form-select w-auto"
      onChange={(e) => changeLanguage(e.target.value)}
      value={i18n.language}
    >
      <option value="en">English</option>
      <option value="hi">हिन्दी</option>
      <option value="gu">ગુજરાતી</option>
      <option value="mr">मराठी</option>
      <option value="kn">ಕನ್ನಡ</option>
      <option value="ml">മലയാളം</option>
      <option value="or">ଓଡ଼ିଆ</option>
      <option value="pa">ਪੰਜਾਬੀ</option>
      <option value="ta">தமிழ்</option>
      <option value="te">తెలుగు</option>
      <option value="ben">বাংলা</option>
    </select>
  );
};

export default LanguageSwitcher;
